import { findBestMatchingNavigationItemByPath, findTopLevelNavigationItemByPath } from "@/common/helpers/route";
import { useRouteConfig } from "@/common/hooks/use-navigation";
import { navigationConfig } from "@/config/navigation/navigation.config";
import type { NavigationItem } from "@/config/navigation/types";
import { MAX_RECENT_VISITS, recentVisitsStore, type RecentVisit } from "@/store/recent-visits/recent-visits-store";
import { useMemo } from "react";

export type PermittedRecentVisit = {
  visit: RecentVisit;
  navigationItem: NavigationItem;
  moduleItem?: NavigationItem;
};

export function usePermittedRecentVisits(): PermittedRecentVisit[] {
  const { routeConfig } = useRouteConfig();
  const recentVisits = recentVisitsStore((state) => state.recentVisits);

  return useMemo(
    () =>
      recentVisits
        .flatMap((visit) => {
          const navigationItem = findBestMatchingNavigationItemByPath(routeConfig, visit.path);
          const configuredItem = findBestMatchingNavigationItemByPath(navigationConfig, visit.path);
          if (!navigationItem || navigationItem.routePath !== configuredItem?.routePath) return [];

          return [{ visit, navigationItem, moduleItem: findTopLevelNavigationItemByPath(routeConfig, visit.path) }];
        })
        .slice(0, MAX_RECENT_VISITS),
    [recentVisits, routeConfig],
  );
}
